import React, { useState, createContext, useContext } from "react";

const PendingMessagesContext = createContext();

const PendingMessagesProvider = ({ children }) => {
  const [pendingMessages, setPendingMessages] = useState([]);

  const addPendingMessage = (body, ticketId) => {
    const id = `pending_${Date.now()}_${Math.random()}`;
    const msg = {
      id,
      body,
      fromMe: true,
      ack: 0,
      createdAt: new Date().toISOString(),
      ticketId: +ticketId,
      mediaType: "chat",
      isDeleted: false,
      isPending: true,
    };
    setPendingMessages(prev => [...prev, msg]);
    // Red de seguridad: si el eco por socket nunca llega, se quita la burbuja
    // optimista. Tiene que ser mayor que lo que puede tardar el envío en el
    // backend esperando el ack del servidor de WhatsApp
    // (WA_SEND_ACK_TIMEOUT_MS, 15 s por defecto), o la burbuja desaparecería
    // justo antes de que llegue el mensaje real y parecería que se perdió.
    setTimeout(() => {
      setPendingMessages(prev => prev.filter(m => m.id !== id));
    }, 30000);
    return id;
  };

  const removePendingById = (id) => {
    setPendingMessages(prev => prev.filter(m => m.id !== id));
  };

  const removePendingByBody = (body, ticketId) => {
    setPendingMessages(prev => {
      // Try exact body match first (most recent match, searching in reverse)
      const reversed = [...prev].reverse();
      const revIdx = reversed.findIndex(
        m => m.body === body && m.ticketId === +ticketId
      );
      if (revIdx !== -1) {
        const realIdx = prev.length - 1 - revIdx;
        return prev.filter((_, i) => i !== realIdx);
      }
      // Fallback: the server may have transformed the body (e.g. formatBody/Mustache).
      // Remove the oldest pending message for this ticket so it doesn't linger.
      const firstIdx = prev.findIndex(m => m.ticketId === +ticketId);
      if (firstIdx !== -1) {
        return prev.filter((_, i) => i !== firstIdx);
      }
      return prev;
    });
  };

  return (
    <PendingMessagesContext.Provider value={{ pendingMessages, addPendingMessage, removePendingByBody, removePendingById }}>
      {children}
    </PendingMessagesContext.Provider>
  );
};

const usePendingMessages = () => useContext(PendingMessagesContext);

export { PendingMessagesContext, PendingMessagesProvider, usePendingMessages };
